/* cache-bust: 2026-10-05-ordered-insert */
(function () {
  'use strict';

  var section = document.getElementById('CollectionSection');
  if (!section) return;

  var grid = document.getElementById('collection-grid');
  var navList = document.getElementById('collection-navigation-list');
  var sentinel = document.getElementById('infinite-scroll-sentinel');
  var loader = document.getElementById('infinite-scroll-loader');
  if (!grid || !sentinel) return;

  var collectionUrl = section.getAttribute('data-collection-url');
  var sectionId = section.getAttribute('data-section-id');
  var totalPages = parseInt(sentinel.getAttribute('data-total-pages'), 10) || 1;

  var loadedPages = {};
  var loadingPromise = null;
  var nextBatchToReveal = 2;
  var allProducts = [];
  var seenCardIds = {};

  function registerExistingCards(container) {
    var cards = container.querySelectorAll('.product-card[id]');
    cards.forEach(function (card) {
      seenCardIds[card.id] = true;
    });
  }
  registerExistingCards(grid);

  function parsePageJson(pageNum) {
    var script = document.querySelector('script[data-collection-page-json][data-batch="' + pageNum + '"]');
    if (!script) return;
    try {
      var data = JSON.parse(script.textContent);
      allProducts = allProducts.concat(data);
    } catch (e) {
      console.error('collection-infinite: JSON parse error page', pageNum, e);
    }
  }
  parsePageJson(1);
  loadedPages[1] = true;

  function initCardInteractions(container) {
    var cards = container.querySelectorAll('.product-card');
    cards.forEach(function (card) {
      var handle = card.id;
      if (!handle || card.dataset.interactionsBound) return;
      card.dataset.interactionsBound = '1';

      var options = card.querySelectorAll('.quick-shop__option-color, .product-card__swatch');
      options.forEach(function (option) {
        ['mouseenter', 'click', 'touchstart'].forEach(function (eventType) {
          option.addEventListener(eventType, function (event) {
            event.preventDefault();
            var color = event.currentTarget.dataset.backgroundColor || event.currentTarget.dataset.color;
            var images = card.querySelectorAll('.image_quickview');
            images.forEach(function (img) {
              img.style.opacity = (img.dataset.color === color) ? '1' : '0';
            });
            var swatches = card.querySelectorAll('.product-card__swatch');
            swatches.forEach(function (s) { s.style.outline = 'none'; });
            if (event.currentTarget.classList.contains('product-card__swatch')) {
              event.currentTarget.style.outline = '2px solid #000';
              event.currentTarget.style.outlineOffset = '2px';
            }
          });
        });
      });

      var altOptions = card.querySelectorAll('.product-card__swatch-alt');
      altOptions.forEach(function (option) {
        option.addEventListener('mouseenter', function (event) {
          var color = event.currentTarget.dataset.color;
          var images = card.querySelectorAll('.image_quickview');
          images.forEach(function (img) {
            img.style.opacity = (img.dataset.color === color) ? '1' : '0';
          });
        });
      });
    });
  }
  initCardInteractions(grid);

  // Numero de page d'un element deja insere (1 si pas d'attribut = page initiale)
  function batchOf(el) {
    var b = parseInt(el.getAttribute('data-batch'), 10);
    return isNaN(b) ? 1 : b;
  }
  // Premier enfant de container appartenant a une page strictement superieure
  function firstChildAfterPage(container, pageNum) {
    var kids = container.children;
    for (var i = 0; i < kids.length; i++) {
      if (batchOf(kids[i]) > pageNum) return kids[i];
    }
    return null;
  }

  var pageData = {};

  function fetchPage(pageNum) {
    if (loadedPages[pageNum]) return Promise.resolve();
    var sep = collectionUrl.indexOf('?') > -1 ? '&' : '?';
    var url = collectionUrl + sep + 'page=' + pageNum + '&section_id=' + encodeURIComponent(sectionId);

    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newCards = doc.querySelectorAll('#collection-grid .product-card');
        var frag = document.createDocumentFragment();
        newCards.forEach(function (card) {
          if (card.id && seenCardIds[card.id]) return;
          if (card.id) seenCardIds[card.id] = true;
          card.classList.add('is-pending-reveal');
          card.setAttribute('data-batch', pageNum);
          frag.appendChild(card);
        });
        // Insertion a la bonne place (ordre de la collection), meme si les pages arrivent dans le desordre
        grid.insertBefore(frag, firstChildAfterPage(grid, pageNum));
        initCardInteractions(grid);

        document.querySelectorAll('.is-pending-reveal[data-batch="' + pageNum + '"]').forEach(function (card) {
          card.classList.remove('is-pending-reveal');
        });

        var newNavItems = doc.querySelectorAll('#collection-navigation-list li');
        newNavItems.forEach(function (li) {
          var key = li.getAttribute('data-collection-key');
          var handle = li.getAttribute('data-handle');
          var existsSelector = key
            ? '[data-collection-key="' + CSS.escape(key) + '"]'
            : '[data-handle="' + CSS.escape(handle) + '"]';
          if (!navList.querySelector(existsSelector)) {
            li.setAttribute('data-batch', pageNum);
            navList.insertBefore(li, firstChildAfterPage(navList, pageNum));
          }
        });

        var jsonScript = doc.querySelector('script[data-collection-page-json]');
        if (jsonScript) {
          try {
            pageData[pageNum] = JSON.parse(jsonScript.textContent);
          } catch (e) {
            console.error('collection-infinite: JSON parse error fetched page', pageNum, e);
          }
        }

        loadedPages[pageNum] = true;
      });
  }

  function ensureAllPagesLoaded() {
    if (loadingPromise) return loadingPromise;

    var pagesToLoad = [];
    for (var p = 2; p <= totalPages; p++) {
      if (!loadedPages[p]) pagesToLoad.push(p);
    }
    if (pagesToLoad.length === 0) {
      loadingPromise = Promise.resolve();
      return loadingPromise;
    }

    var concurrency = 3;
    var index = 0;
    function worker() {
      if (index >= pagesToLoad.length) return Promise.resolve();
      var page = pagesToLoad[index++];
      return fetchPage(page).then(worker);
    }
    var workers = [];
    for (var i = 0; i < concurrency; i++) workers.push(worker());

    loadingPromise = Promise.all(workers);
    return loadingPromise;
  }

  // Les pages ne sont chargees qu'a la demande (scroll, filtre, ou clic sur une icone du menu).

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealNextBatch();
    });
  }, { rootMargin: '400px 0px' });
  observer.observe(sentinel);

  function revealNextBatch() {
    while (nextBatchToReveal <= totalPages && loadedPages[nextBatchToReveal]) {
      nextBatchToReveal++;
    }
    var pending = document.querySelectorAll('.is-pending-reveal[data-batch="' + nextBatchToReveal + '"]');
    if (pending.length === 0) {
      if (nextBatchToReveal <= totalPages) {
        fetchPage(nextBatchToReveal).then(function () {
          setTimeout(revealNextBatch, 50);
        }).catch(function () {
          nextBatchToReveal++;
          if (nextBatchToReveal <= totalPages) {
            setTimeout(revealNextBatch, 50);
          } else {
            if (loader) loader.classList.remove('is-active');
            observer.disconnect();
          }
        });
        return;
      }
      if (loader) loader.classList.remove('is-active');
      observer.disconnect();
      return;
    }
    pending.forEach(function (card) { card.classList.remove('is-pending-reveal'); });
    if (loader) loader.classList.remove('is-active');
    nextBatchToReveal++;
    if (nextBatchToReveal > totalPages) observer.disconnect();
  }

  // Clic sur une icone du menu dont le produit n'est pas encore charge :
  // on charge toutes les pages puis on rejoue le clic pour que l'ancre fonctionne.
  if (navList) {
    var replaying = false;
    navList.addEventListener('click', function (event) {
      if (replaying) return;
      var link = event.target.closest ? event.target.closest('a.inner-link') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var targetId = href.slice(1);
      if (document.getElementById(targetId)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      document.body.style.cursor = 'progress';
      ensureAllPagesLoaded().then(function () {
        document.body.style.cursor = '';
        if (!document.getElementById(targetId)) return;
        replaying = true;
        link.click();
        replaying = false;
      }).catch(function () {
        document.body.style.cursor = '';
      });
    }, true);
  }

  window.__collectionInfinite = {
    ensureAllPagesLoaded: ensureAllPagesLoaded,
    // Donnees produits dans l'ordre des pages (page 1 deja parsee + pages chargees)
    getAllProducts: function () {
      var out = allProducts.slice();
      Object.keys(pageData).map(Number).sort(function (a, b) { return a - b; }).forEach(function (p) {
        out = out.concat(pageData[p]);
      });
      return out;
    },
    revealAllCards: function () {
      document.querySelectorAll('.is-pending-reveal').forEach(function (card) {
        card.classList.add('is-filter-revealed');
        card.classList.remove('is-pending-reveal');
      });
    },
    restoreScrollReveal: function () {
      document.querySelectorAll('.is-filter-revealed').forEach(function (card) {
        card.classList.remove('is-filter-revealed');
      });
    }
  };
})();
